import INVENTORY_API_BASE_URL from "../../config/api";
import React, { useState, useEffect } from "react";
import "./CreateShipment.css";
import Axios from "axios";
import { useNavigate } from "react-router-dom";
import alertify from "alertifyjs";

const CreateShipment = () => {
  const [data, setData] = useState([]);
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [totalWeight, setTotalWeight] = useState(0);
  const [selectedShipments, setSelectedShipments] = useState([]);
  const [inputValues, setInputValues] = useState({});
  const [selectedShipmentId, setSelectedShipmentId] = useState(null);
  const [checkboxStatus, setCheckboxStatus] = useState({});
  const [isCreatingShipment, setIsCreatingShipment] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10); 
  const [totalPages, setTotalPages] = useState(0);

  function formatDate(dateString) {
    const date = new Date(dateString);
    const options = { day: "numeric", month: "long", year: "numeric" };
    return date.toLocaleDateString("en-US", options);
  }

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getshipment`).then(
      (response) => {
        const latest30Data = response.data;
        setData(latest30Data);
      }
    );
  }, []);

  const filteredData = data.filter((row) => Boolean(row.ApprovalDate));

  const navigate = useNavigate();

  const handleInputChange = (shipmentid, value) => {
    setInputValues((prevInputValues) => ({
      ...prevInputValues,
      [shipmentid]: value,
    }));
  };

  const handleCheckboxChange = (shipmentid) => {
    setCheckboxStatus((prevStatus) => ({
      ...prevStatus,
      [shipmentid]: !prevStatus[shipmentid], 
    }));
    if (selectedShipments.includes(shipmentid)) {
      setSelectedShipments((prevSelected) =>
        prevSelected.filter((id) => id !== shipmentid)
      );
    } else {
      setSelectedShipments((prevSelected) => [...prevSelected, shipmentid]);
    }
  };

  const getSelectedShipmentData = () => {
    const selectedData = [];

    const selectedShipmentIds = new Set();

    filteredData.forEach((row) => {
      if (selectedShipments.includes(row.shipmentid)) {
        const inputValue = inputValues[row.shipmentid] || "";

        row.updatedQuantity.forEach((item) => {
          const totalValue = (item.approvedquantity * item.weight) / 1000;

          if (!selectedShipmentIds.has(row.shipmentid)) {
            selectedShipmentIds.add(row.shipmentid);

            const shipmentData = {
              orderId: row.shipmentid,
              numberOfBoxes: parseInt(inputValue),
              OrderDetails: [
                {
                  title: item.title,
                  Medium: item.Medium,
                  edition: item.edition,
                  sku: item.sku,
                  approvedquantity: item.approvedquantity,
                  weight: item.weight,
                  totalBookWeight: totalValue,
                },
              ],
            };
            selectedData.push(shipmentData);
          } else {
            selectedData[selectedData.length - 1].OrderDetails.push({
              title: item.title,
              Medium: item.Medium,
              edition: item.edition,
              sku: item.sku,
              approvedquantity: item.approvedquantity,
              weight: item.weight,
              totalBookWeight: totalValue,
            });
          }
        });
      }
    });
    return selectedData;
  };

  const calculateTotalQuantity = () => {
    let totalQuantity = 0;

    selectedShipments.forEach((shipmentId) => {
      const shipmentData = filteredData.find(
        (row) => row.shipmentid === shipmentId
      );

      if (shipmentData) {
        shipmentData.updatedQuantity.forEach((item) => {
          totalQuantity += item.approvedquantity;
        });
      }
    });

    return totalQuantity;
  };

  const calculateTotalWeight = () => {
    let totalWeight = 0;

    selectedShipments.forEach((shipmentId) => {
      const shipmentData = filteredData.find(
        (row) => row.shipmentid === shipmentId
      );

      if (shipmentData) {
        shipmentData.updatedQuantity.forEach((item) => {
          totalWeight += (item.approvedquantity * item.weight) / 1000;
        });
      }
    });
    return totalWeight;
  };

  const calculateTotalBoxes = () => {
    let totalBoxes = 0;
    selectedShipments.forEach((shipmentId) => {
      const inputValue = inputValues[shipmentId];
      if (inputValue) {
        totalBoxes += parseInt(inputValue);
      }
    });
    return totalBoxes;
  };
  const totalBoxes = calculateTotalBoxes();
  useEffect(() => {
    setTotalQuantity(calculateTotalQuantity());
    setTotalWeight(calculateTotalWeight());
  }, [selectedShipments, filteredData]);

  const handleCreateShipment = () => {
    if (selectedShipments.length === 0) {
      alertify.alert("At least select One Order ID");
      return;
    }
    const areAllInputsFilled = selectedShipments.every((shipmentId) => {
      return Boolean(inputValues?.[shipmentId]);
    });

    if (!areAllInputsFilled) {
      alertify.alert(
        "Please fill in the number of boxes for all selected shipments."
      );
      return;
    }

    setIsCreatingShipment(true);

    const selectedShipmentData = getSelectedShipmentData();
    const shipmentData = {
      totalBoxes: totalBoxes,
      totalQuantity: totalQuantity,
      totalWeight: totalWeight,
      ShipmentDetails: selectedShipmentData.map((shipment) => ({
        orderId: shipment.orderId,
        numberOfBoxes: shipment.numberOfBoxes,
        OrderDetails: shipment.OrderDetails.map((orderDetail) => ({
          title: orderDetail.title,
          Medium: orderDetail.Medium,
          edition: orderDetail.edition,
          SKU: orderDetail.sku,
          approvedquantity: orderDetail.approvedquantity,
          totalBookWeight: orderDetail.totalBookWeight,
        })),
      })),
    };

    setSelectedShipments([]);
    setInputValues({});
    setSelectedShipmentId(null);

    const numRows = totalBoxes;
    navigate(`/GeneratedTablePage/${numRows}`, {
      state: { shipmentData },
    });
  };
  const selectedShipmentData = getSelectedShipmentData();

  useEffect(() => {
    if (data.length > 0) {
      const pages = Math.ceil(data.length / itemsPerPage);
      setTotalPages(pages);
    }
  }, [data, itemsPerPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const paginate = (array, page_number, page_size) => {
    return array.slice((page_number - 1) * page_size, page_number * page_size);
  };

  const getPageRange = () => {
    const maxPagesToShow = 15;
    const middlePage = Math.ceil(maxPagesToShow / 2);
    let startPage = Math.max(currentPage - middlePage, 1);
    let endPage = Math.min(startPage + maxPagesToShow - 1, totalPages);

    if (endPage - startPage < maxPagesToShow - 1) {
      startPage = Math.max(endPage - maxPagesToShow + 1, 1);
    }

    endPage = Math.min(endPage, totalPages);

    startPage = Math.max(endPage - maxPagesToShow + 1, 1);

    return Array.from(
      { length: endPage - startPage + 1 },
      (_, index) => startPage + index
    );
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  return (
    <div className="createshipment-container">
      <main className="create-shipment-content">
        <header className="create-shipment-hero">
          <div className="create-shipment-hero-copy">
            <span className="create-shipment-eyebrow">
              <span className="create-shipment-eyebrow-mark" />
              OUTBOUND OPERATIONS
            </span>
            <h1>Create shipment</h1>
            <p>
              Select approved orders, enter the number of boxes, and review
              shipment contents before generating the packing list.
            </p>
          </div>
          <div className="create-shipment-hero-tag">
            <span className="create-shipment-live-dot" />
            Ready to prepare
          </div>
        </header>

        <section className="create-shipment-summary" aria-label="Shipment totals">
          <article className="create-shipment-stat">
            <span className="create-shipment-stat-label">Selected orders</span>
            <strong>{selectedShipments.length}</strong>
            <span className="create-shipment-stat-hint">Orders in this shipment</span>
          </article>
          <article className="create-shipment-stat">
            <span className="create-shipment-stat-label">Total boxes</span>
            <strong>{totalBoxes}</strong>
            <span className="create-shipment-stat-hint">Boxes to prepare</span>
          </article>
          <article className="create-shipment-stat">
            <span className="create-shipment-stat-label">Total quantity</span>
            <strong>{totalQuantity}</strong>
            <span className="create-shipment-stat-hint">Approved books</span>
          </article>
          <article className="create-shipment-stat">
            <span className="create-shipment-stat-label">Estimated weight</span>
            <strong>{totalWeight.toFixed(2)} <small>kg</small></strong>
            <span className="create-shipment-stat-hint">Calculated from order lines</span>
          </article>
        </section>

        <section className="create-shipment-panel">
          <div className="create-shipment-section-heading">
            <div>
              <span className="create-shipment-section-eyebrow">ORDER QUEUE</span>
              <h2>Choose orders to ship</h2>
              <p>Select an order and enter the box count for each selected order.</p>
            </div>
            <span className="create-shipment-count">
              {data.length} {data.length === 1 ? "order" : "orders"} available
            </span>
          </div>

          <div className="create-shipment-pagination">
            <span className="create-shipment-page-label">
              Page <strong>{currentPage}</strong> of <strong>{totalPages}</strong>
            </span>
            <nav className="create-shipment-page-buttons" aria-label="Order pagination">
              <button
                className="create-shipment-page-button create-shipment-page-button-secondary"
                type="button"
                onClick={handlePreviousPage}
                disabled={currentPage === 1}
              >
                <span aria-hidden="true">‹</span> Previous
              </button>

              {getPageRange().map((pageNumber) => (
                <button
                  className="create-shipment-page-button"
                  key={pageNumber}
                  type="button"
                  onClick={() => handlePageChange(pageNumber)}
                  disabled={pageNumber === currentPage}
                  aria-current={pageNumber === currentPage ? "page" : undefined}
                >
                  {pageNumber}
                </button>
              ))}

              <button
                className="create-shipment-page-button create-shipment-page-button-secondary"
                type="button"
                onClick={handleNextPage}
                disabled={currentPage === totalPages}
              >
                Next <span aria-hidden="true">›</span>
              </button>
            </nav>
          </div>

          <div className="create-shipment-order-list">
            {paginate(data, currentPage, itemsPerPage).length === 0 ? (
              <div className="create-shipment-empty">
                <span className="create-shipment-empty-icon" aria-hidden="true">□</span>
                <h3>No orders available</h3>
                <p>Approved orders will appear here when they are ready to ship.</p>
              </div>
            ) : (
              paginate(data, currentPage, itemsPerPage).map((row) => (
                <article className="create-shipment-order" key={row.shipmentid}>
                  <label className="create-shipment-select">
                    <input
                      type="checkbox"
                      checked={checkboxStatus[row.shipmentid] || false}
                      onChange={() => handleCheckboxChange(row.shipmentid)}
                      aria-label={"Select order " + row.shipmentid}
                    />
                    <span className="create-shipment-checkbox" aria-hidden="true" />
                  </label>

                  <div className="create-shipment-order-main">
                    <span className="create-shipment-order-kicker">ORDER ID</span>
                    <strong className="create-shipment-order-id">{row.shipmentid}</strong>
                    <span
                      className={
                        "create-shipment-status" +
                        (row.ApprovalDate ? " create-shipment-status-approved" : " create-shipment-status-pending")
                      }
                    >
                      <span />
                      {row.ApprovalDate ? "Approved" : "Approval pending"}
                    </span>
                  </div>

                  <div className="create-shipment-order-meta">
                    <div className="create-shipment-meta-item">
                      <span>Distributor</span>
                      <strong>{row.distributorName}</strong>
                    </div>
                    <div className="create-shipment-meta-item">
                      <span>Order date</span>
                      <strong>{formatDate(row.orderdate)}</strong>
                    </div>
                  </div>

                  <label className="create-shipment-box-field">
                    <span>Number of boxes</span>
                    <input
                      name="boxes"
                      type="number"
                      value={inputValues[row.shipmentid] || ""}
                      onChange={(e) =>
                        handleInputChange(row.shipmentid, e.target.value)
                      }
                      required={selectedShipmentId === row.shipmentid}
                      onWheel={(e) => e.target.blur()}
                    />
                  </label>
                </article>
              ))
            )}
          </div>
        </section>

        <section className="create-shipment-panel create-shipment-review">
          <div className="create-shipment-section-heading">
            <div>
              <span className="create-shipment-section-eyebrow">PACKING REVIEW</span>
              <h2>Selected order contents</h2>
              <p>Review the approved book quantities and box counts before continuing.</p>
            </div>
            <span className="create-shipment-count">
              {selectedShipmentData.length} {selectedShipmentData.length === 1 ? "selected order" : "selected orders"}
            </span>
          </div>

          {selectedShipmentData.length === 0 ? (
            <div className="create-shipment-review-empty">
              Select an approved order above to see its books and quantities here.
            </div>
          ) : (
            <div className="create-shipment-review-list">
              {selectedShipmentData.map((shipment, index) => (
                <article
                  className="create-shipment-review-order"
                  key={shipment.orderId + "-" + index}
                >
                  <div className="create-shipment-review-order-heading">
                    <div>
                      <span className="create-shipment-order-kicker">ORDER ID</span>
                      <strong>{shipment.orderId}</strong>
                      <span className="create-shipment-line-count">
                        {shipment.OrderDetails.length} {shipment.OrderDetails.length === 1 ? "line item" : "line items"}
                      </span>
                    </div>
                    <span className="create-shipment-box-badge">
                      {shipment.numberOfBoxes} {shipment.numberOfBoxes === 1 ? "box" : "boxes"}
                    </span>
                  </div>

                  <div className="create-shipment-line-list">
                    {shipment.OrderDetails.map((orderDetail, detailIndex) => (
                      <article
                        className="create-shipment-line-item"
                        key={shipment.orderId + "-detail-" + detailIndex}
                      >
                        <div className="create-shipment-line-title">
                          <span className="create-shipment-sku">SKU {orderDetail.sku}</span>
                          <h3>{orderDetail.title}</h3>
                        </div>
                        <dl className="create-shipment-line-fields">
                          <div>
                            <dt>Medium</dt>
                            <dd>{orderDetail.Medium}</dd>
                          </div>
                          <div>
                            <dt>Edition</dt>
                            <dd>{orderDetail.edition}</dd>
                          </div>
                          <div>
                            <dt>Approved quantity</dt>
                            <dd>{orderDetail.approvedquantity}</dd>
                          </div>
                        </dl>
                      </article>
                    ))}
                  </div>
                </article>
              ))}
            </div>
          )}
        </section>

        <footer className="create-shipment-footer">
          <div className="create-shipment-footer-copy">
            <span className="create-shipment-section-eyebrow">SHIPMENT TOTALS</span>
            <strong>{totalBoxes} {totalBoxes === 1 ? "box" : "boxes"} <span>·</span> {totalQuantity} books</strong>
            <span>{totalWeight.toFixed(2)} kg estimated weight</span>
          </div>
          <button
            className="button-7"
            type="button"
            onClick={handleCreateShipment}
            disabled={isCreatingShipment}
          >
            {isCreatingShipment ? "Creating shipment…" : "Create shipment"}
            <span aria-hidden="true">→</span>
          </button>
        </footer>
      </main>
    </div>
  );
};

export default CreateShipment;
